import './App.css'
import React, { useState, useEffect } from "react";
import { AppContext, useApiContext } from "./util/context";
import AppRoutes from "./Routes";
import { ConfigProvider } from 'antd';
import { Hub } from 'aws-amplify/utils';
import {signInWithRedirect, getCurrentUser, fetchUserAttributes, signOut} from 'aws-amplify/auth';
import { Loading } from './components/Loading';
import { Landing } from './pages/Landing/Landing';
import styled from 'styled-components';
import '@aws-amplify/ui-react/styles.css';
import { listEmployeeUsers } from './util/myQueries';


const StyledDiv = styled.div`
    font-family: "Poppins", sans-serif;
`;

function App() {
  const { EmployeeApiKeyClient } = useApiContext();
  const [isRep, setIsRep] = useState(false);
  //const [isAdmin, setIsAdmin] = useState(false);  
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true)
  const [showAuthenticator, setShowAuthenticator] = useState(false); 
  const [allEmployeeUsers, setAllEmployeeUsers] = useState([]);
  const [error, setError] = useState(false);

  async function getAllEmployeeUsers() {
    let allItems = [];
    let nextToken = null;
    do {
      const response = await EmployeeApiKeyClient.graphql({
        query: listEmployeeUsers,
        variables: {
          limit: 100,
          nextToken,
        },
      });

      const data = response.data.listEmployees;
      allItems = [...allItems, ...data.items];
      nextToken = data.nextToken;
    } while (nextToken);
    return allItems;
  }

  async function getEmployeeUsers() {
    try {
      const employeeUsers = await getAllEmployeeUsers();
      setAllEmployeeUsers(employeeUsers);
    }catch(error) {
      console.log("Error fetching employee users:", error);
      setError(true);
    }
  }

  useEffect(() => {
    const unsubscribe = Hub.listen("auth", ({ payload: { event } }) => {
        switch (event) {
          case "signedIn":
            setLoading(true);
            //put datastore syncing logic in here?
            getUser()
            break;
          case "signedOut":
            //setLoading(true);
            setShowAuthenticator(false);
            setUserData(null);
            // Remove user from the state
            //Cache.clear(); // Remove cached data from the previous user
            break;
          default:
            break;
        }
      });
  
      getUser();
  
    return () => {
        unsubscribe();
    };
}, []); 

  function getRepEmails() {
    const emails = process.env.REACT_APP_REP_EMAILS || '';
    return new Set(emails.split(','));
  }
  
  function isUserRep(userEmail) {
    const repEmails = getRepEmails();
    return repEmails.has(userEmail);
  }

  async function getUser() {
    try {
      const user = await getCurrentUser()
      const attributes = await fetchUserAttributes();
      setUserData(attributes);
      if (isUserRep(attributes.email)) {
        setIsRep(true);
        await getEmployeeUsers();
      }
      setShowAuthenticator(true);
    } catch (error) {
      //console.log(error)
    }finally {
      setLoading(false);
    }
  }

  const handleSignOut = async () => {
    await signOut();
  }
  

  function SignIn() { 
    try{
      signInWithRedirect({
        provider: {
          custom: process.env.REACT_APP_ENTRAID
        }
      })
      
    }catch(error){
      //console.log(error)
    }
  }

  if (loading) {
    return <Loading />
  }

  return (
    <AppContext.Provider value={{
      userData,
      setUserData,
      isRep,
      allEmployeeUsers,
      StyledDiv,
      SignIn: SignIn,
      handleSignOut: handleSignOut
    }}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: 'rgb(174,32,114)'
          },
        }}
      
      >
        {showAuthenticator && <AppRoutes
          appProps={{
            signOut: null,
            user: null
          }}
        />}

        {!showAuthenticator && <Landing setShowAuthenticator={setShowAuthenticator}/>}

      </ConfigProvider>
    </AppContext.Provider>
  );
}

export default App;
